function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Row, Col, Input, Label } from 'reactstrap';
import Collector from "../../../../services/collector";
import { useWorkFlow } from "../../../contexts/workflow";
import { _Security, _translate } from "../../../../services/core";
var TimeClassic = function TimeClassic(props) {
  var onChange = props.onChange,
    index = props.index;
  var _useWorkFlow = useWorkFlow(),
    collector = _useWorkFlow.collector;
  var currentOrder = collector.currentOrder,
    responses = collector.responses,
    currentQuestion = collector.currentQuestion;
  var _currentQuestion$publ = currentQuestion === null || currentQuestion === void 0 ? void 0 : currentQuestion.publicParameters,
    defaultValue = _currentQuestion$publ.defaultValue;
  var _useState = useState(defaultValue || '00:00'),
    _useState2 = _slicedToArray(_useState, 2),
    timeValue = _useState2[0],
    setTimeValue = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isUnknown = _useState4[0],
    setIsUnknown = _useState4[1];
  var handleOnChange = function handleOnChange(event) {
    var value = event.target.value;
    setTimeValue(value);
    var _value$split$map = value.split(':').map(Number),
      _value$split$map2 = _slicedToArray(_value$split$map, 2),
      hours = _value$split$map2[0],
      minutes = _value$split$map2[1];
    var totalMinutes = hours * 60 + minutes;
    onChange(null, totalMinutes, null, null, index, true);
  };
  var handleCheckboxChange = function handleCheckboxChange() {
    setIsUnknown(!isUnknown);
    if (!isUnknown) {
      setTimeValue(defaultValue || '00:00');
      onChange(null, 'NA', null, null, index, true);
    } else {
      setTimeValue(defaultValue || '00:00');
    }
  };
  var init = function init() {
    var responsesFromHistoric = Collector.getCurrentOrderResponses(currentOrder, responses);
    var savedResponses = responsesFromHistoric === null || responsesFromHistoric === void 0 ? void 0 : responsesFromHistoric.responses;
    if (savedResponses) {
      Object.keys(savedResponses).forEach(function (key) {
        var totalMinutes = savedResponses[key];
        if (totalMinutes === 'NA') {
          setIsUnknown(true);
          setTimeValue(defaultValue || '00:00');
        } else {
          var hours = Math.floor(totalMinutes / 60);
          var minutes = totalMinutes % 60;
          var formattedTime = "".concat(String(hours).padStart(2, '0'), ":").concat(String(minutes).padStart(2, '0'));
          setTimeValue(formattedTime);
        }
      });
    }
  };
  useEffect(function () {
    if (!currentQuestion) {
      return;
    }
    init();
  }, [currentQuestion, responses]);
  return /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center'
    }
  }, /*#__PURE__*/React.createElement(Input, {
    type: "time",
    style: {
      width: '150px'
    },
    value: timeValue,
    onChange: handleOnChange,
    disabled: isUnknown
  }), /*#__PURE__*/React.createElement(Label, {
    check: true,
    style: {
      marginTop: '10px'
    }
  }, /*#__PURE__*/React.createElement(Input, {
    type: "checkbox",
    checked: isUnknown,
    onChange: handleCheckboxChange
  }), ' ', _translate('collectorapp_dont_know')));
};
TimeClassic.propTypes = {
  onChange: PropTypes.func.isRequired,
  elements: PropTypes.arrayOf(PropTypes.shape({}))
};
TimeClassic.defaultProps = {
  elements: [],
  responses: {}
};
export default TimeClassic;